import Vue from 'vue';
import VueRouter from 'vue-router';
import system from './system';
import knowledge from './knowledge';
import notice from './notice';
// import safety from './safety';
import asset from './asset';
import unit from './unit';
// import task from './task';
import todo from './todo';
import docking from './docking';
const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Home = () => import(/* webpackChunkName: "base" */'@/components/pages/Home');
const Login = () => import(/* webpackChunkName: "base" */'@/components/pages/Login');
const LoginRephrase = () => import(/* webpackChunkName: "base" */'@/components/pages/LoginRephrase');
const Redirect = () => import(/* webpackChunkName: "base" */'@/components/common/Redirect');
const NotFound = () => import(/* webpackChunkName: "base" */'@/components/pages/NotFound');
const EasyRead = () => import(/* webpackChunkName: "base" */'@/components/common/EasyRead');

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export const basicRouters = [
  {
    path: '/Login',
    name: 'login',
    component: Login,
    meta: {
      roles: [],
      icon: 'Login',
      hidden: true
    },
  },
  {
    path: '/webadmin',
    name: 'webadmin',
    component: LoginRephrase,
    meta: {
      roles: [],
      hidden: true
    },
  },
  {
    path: '/easy-read',
    name: 'easyRead',
    component: EasyRead,
    meta: {
      roles: [],
      hidden: true
    }
  },
  {
    path: '/403',
    name: '403',
    component: NotFound,
    meta: {
      roles: [],
      hidden: true
    },
  },
  {
    path: '/home',
    component: Layout,
    meta: {
      roles: [],
      icon: 'home'
    },
    children: [{
      path: '',
      name: 'home',
      component: Home,
      meta: {
        title: '首页',
        icon: 'home',
        activeMenu: '/home',
        componentName: 'Home',
      }
    }]
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: Layout,
    meta: {
      hidden: true
    },
    children: [
      {
        path: '/redirect/:path*',
        component: Redirect
      }
    ]
  },
];

export const routes = [
  // ...safety,
  ...notice,
  ...todo,
  ...asset,
  ...docking,
  ...knowledge,
  ...unit,
  ...system,
  {
    path: '*',
    component: NotFound,
    meta: {
      roles: [],
      hidden: true
    },
  },
];

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: '/',
    routes: basicRouters
  });

const router = createRouter();

router.resetRouter = params => {
  router.matcher = createRouter().matcher;
  params.forEach(e => {
    router.addRoute(e);
  });
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js